import {
    useRef,
} from 'react';
import PropTypes from 'prop-types';

import { useIntersectionObserver } from '../../hooks';

const LazyLoad = ({
    render,
    placeholder,
    options,
}) => {

    const elementRef = useRef(null);
    const {
        isVisible,
        entry,
    } = useIntersectionObserver({
        disconnectOnIntersect: true,
        rootMargin: '0px 0px 200px 0px',
        ...options,
        elementRef,
    });

    if (!isVisible && placeholder) {

        return placeholder;

    }

    return render({
        elementRef,
        isVisible,
        entry,
    });

};

LazyLoad.propTypes = {
    render: PropTypes.func.isRequired,
    options: PropTypes.shape({
        root: PropTypes.element,
        rootMargin: PropTypes.string,
        threshold: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.number,
        ]),
    }),
    placeholder: PropTypes.element,
};

export default LazyLoad;
